import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getVehicleState } from 'store/selectors/vehicle.selector';

import { checkAfgEligibility } from '../utils/afgEligibility.utils';

interface IUseIsEligibleForAfgParams {
  odometer: number | null | undefined;
  vehicleYear: string | number | null | undefined;
}

export const useIsEligibleForAfg = ({ odometer, vehicleYear }: IUseIsEligibleForAfgParams): boolean => {
  const { balloonMaxOdometers } = useSelector(getVehicleState);

  const isEligibleForAfg = useMemo(() => checkAfgEligibility({ balloonMaxOdometers, odometer, vehicleYear }), [
    balloonMaxOdometers,
    odometer,
    vehicleYear,
  ]);

  return isEligibleForAfg;
};
